export type Cookie = {
  name?: string;
  value?: string;
};
